import httpRequest from "@/auth/http-client";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import {
  ConversationReportQuery,
  IConversationReportRow,
} from "@/types/conversation-report.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

const baseConversationUrl = "api/v1/conversation";

export async function getConversationReport(
  query: ConversationReportQuery,
  pagination: RequestPagination
): Promise<PaginatedResponse<IConversationReportRow>> {
  const paginationQuery = buildPaginationQuery(pagination);
  return httpRequest.post(
    `${baseConversationUrl}/report?${paginationQuery}`,
    query as never
  );
}
